// Shared API base resolution for the entire frontend.
//
// In preview / dev we point at REACT_APP_BACKEND_URL (the Emergent ingress
// hostname).  In production we serve the SPA from `sitgesvibes.com` while the
// FastAPI backend is hosted at `vibes-explore-1.emergent.host` — but the
// `sitgesvibes.com` ingress already proxies `/api/*` straight through to the
// backend.  Calling the backend cross-origin from the browser would force
// third-party-cookie handling for the admin auth cookie, which Chrome / Safari
// /  Firefox now block by default.
//
// So when the page is loaded from `(www.)?sitgesvibes.com` we drop the
// hard-coded backend host and use relative `/api/*` paths instead.  This makes
// the auth cookie a first-party cookie and removes CORS from the equation
// entirely.
const RAW = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

const isProdDomain =
  typeof window !== 'undefined' &&
  /(^|\.)sitgesvibes\.com$/i.test(window.location.hostname);

export const API_BASE = isProdDomain ? '' : RAW;
export const BACKEND_URL = API_BASE;
